import { LOGIN_SERVICE_API } from './apis'
import axios from '@/assets/js/axios.js'
// 获取登录验证key
export function loginVt (params) {
  return axios({
    url: LOGIN_SERVICE_API.LOGIN_KEY,
    // url: '/login',
    method: 'get',
    params: params
  })
}

export function login (params) {
  return axios({
    url: LOGIN_SERVICE_API.LOGIN,
    // url: '/login',
    method: 'post',
    data: params
  })
}

export function logout (params) {
  return axios({
    url: LOGIN_SERVICE_API.LOGOUT,
    method: 'get',
    params: params
  })
}
